import { FormProvider, useForm } from 'react-hook-form';
import { t, Trans } from '@lingui/macro';
import _ from 'lodash';
import { Button } from '@material-ui/core';
import FormSection from '../../form/FormSection';
import NgpForm from '../../form/NgpForm';
import { MANUAL_ERROR_TYPE, USE_FORM_DEFAULT_OPTIONS } from '../../../utilities/FormUtilities';
import { useFindById } from '../../../services/FormQueryService';
import AdminPage from '../AdminPage';
import Actions from '../../page-framework/actions/Actions';
import { useFormSaveService, useFormSubmitWrapper } from '../../../services/FormSaveService';
import useBreadcrumb from '../../breadcrumb/UseBreadcrumb';
import { useEntityIdParam } from '../AdminLinkUtils';
import UserPasswordSection from './UserPasswordSection';
import { doPasswordsMatch, PASSWORD_MISMATCH_ERROR_TEXT } from './UserAdminHelper';
import { CONFIRM_PASSWORD_FIELD, PASSWORD_FIELD } from './UserConstants';
import { throwValidationError } from '../../../services/ApiDataService';
import useSession from '../../../stores/SessionStore';
import useEnvironment from '../../../stores/EnvironmentStore';

const pageId = 'userPassword';
const readUrl = '/ipm/v1/admin/usersProfile/';
const writeUrl = '/ipm/v1/admin/userpasswords/';
const defaultValues = {};
const newBreadCrumbText = t`Change Password`;

export default function UserPasswordDetail() {
    const recordId = useEntityIdParam();
    const { submitWrapper, saving } = useFormSubmitWrapper();
    const methods = useForm(USE_FORM_DEFAULT_OPTIONS);
    const { reset, setError, handleSubmit, getValues } = methods;
    const functionBreadCrumbs = [];
    const [, sessionActions] = useSession();
    const [environment] = useEnvironment();
    const formSaveService = useFormSaveService();

    /**
     * Post handling of data coming back from the server
     * @param response
     * @returns {*}
     */
    const postFindByIdHandler = (response) => {
        return response;
    };

    const { initialized, finding, formData, resetForm } = useFindById({
        url: readUrl,
        recordId,
        postFindByIdHandler,
        resetFunc: reset,
        defaultValues,
    });
    const breadcrumbs = useBreadcrumb(functionBreadCrumbs, null, null, null, newBreadCrumbText);

    const handleFormSubmit = (dataToSave = {}) => {
        if (!doPasswordsMatch(getValues(PASSWORD_FIELD), getValues(CONFIRM_PASSWORD_FIELD))) {
            setError(CONFIRM_PASSWORD_FIELD, {
                type: MANUAL_ERROR_TYPE,
                message: PASSWORD_MISMATCH_ERROR_TEXT,
            });
            return throwValidationError();
        }

        return formSaveService
            .save({
                url: writeUrl,
                recordId: formData._id,
                dataToSave: _.extend(dataToSave, { _id: formData._id }),
                setError,
            })
            .then((response) => {
                sessionActions.refresh(environment);
                resetForm();
                return response;
            });
    };

    const handleSubmitFunction = submitWrapper(handleFormSubmit);

    return (
        <AdminPage
            breadcrumbs={breadcrumbs}
            pageId={pageId}
            actions={
                <Actions>
                    <Button onClick={handleSubmit(handleSubmitFunction)} variant="contained" color="primary">
                        <Trans>Save</Trans>
                    </Button>
                </Actions>
            }
        >
            <FormProvider {...methods}>
                <NgpForm submitFunction={handleSubmitFunction} initialized={initialized} loading={finding || saving}>
                    <FormSection title={<Trans>Change Password</Trans>}>
                        <UserPasswordSection showPassword />
                    </FormSection>
                </NgpForm>
            </FormProvider>
        </AdminPage>
    );
}
